import { render, staticRenderFns } from "./zzjiagou2.vue?vue&type=template&id=49c2dd35&scoped=true&"
import script from "./zzjiagou2.vue?vue&type=script&lang=js&"
export * from "./zzjiagou2.vue?vue&type=script&lang=js&"
import style0 from "./zzjiagou2.vue?vue&type=style&index=0&id=49c2dd35&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c2dd35",
  null
  
)

export default component.exports